import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input'];

  connect() {
    // According to MDN range input has a default values of min=0 and max=100, and so we follow the same logic here
    const min = this.inputTarget.min;
    this.min = Number(min) || 0;

    const max = this.inputTarget.max;
    this.max = Number(max) || 100;
  }

  normalize({ target }) {
    const value = Number(target.value);

    if (value < this.min) {
      this.value = this.min;
    }

    if (value > this.max) {
      this.value = this.max;
    }
  }

  /**
   * @param {InputEvent} event
   */
  handleInput({ target }) {
    const value = Number(target.value);

    this.inputTargets.forEach((input) => {
      if (input === target) {
        return;
      }

      input.value = value;
    });

    this.#validValue(value) && this.dispatch('valid-input', { target });
  }

  handleInputWithFocusRecovery({ target }) {
    this.handleInput({ target });

    // Tiptap focuses the focus on itself after input events making it very uncomfortable to use text inputs, so we claim it back after the changes are applied
    setTimeout(() => {
      target.focus();
    }, 150);
  }

  set value(value) {
    this.inputTargets.forEach((input) => (input.value = value));
  }

  #validValue(value) {
    return this.min <= value && value <= this.max;
  }
}
